const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((vitals: any) => {
      // Support both old API (getCLS) and new API (onCLS)
      const getCLS = vitals.onCLS || vitals.getCLS;
      const getFID = vitals.onINP || vitals.onFID || vitals.getFID;
      const getFCP = vitals.onFCP || vitals.getFCP;
      const getLCP = vitals.onLCP || vitals.getLCP;
      const getTTFB = vitals.onTTFB || vitals.getTTFB;
      
      if (getCLS) getCLS(onPerfEntry);
      if (getFID) getFID(onPerfEntry);
      if (getFCP) getFCP(onPerfEntry);
      if (getLCP) getLCP(onPerfEntry);
      if (getTTFB) getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
